import { Component, For, Show } from "solid-js";
import type { CsvColumnMapping } from "../../api/workItems";
import type { PartialCsvMapping } from "../../utils/csv";

export const MAPPABLE_FIELDS: {
  key: keyof CsvColumnMapping;
  label: string;
  required: boolean;
}[] = [
  { key: "title", label: "Title", required: true },
  { key: "description", label: "Description", required: false },
  { key: "item_type", label: "Item Type", required: false },
  { key: "status", label: "Status", required: false },
  { key: "priority", label: "Priority", required: false },
];

export interface CsvMappingFormProps {
  headers: string[];
  mapping: PartialCsvMapping;
  onChange: (next: PartialCsvMapping) => void;
}

export const CsvMappingForm: Component<CsvMappingFormProps> = (props) => {
  const setFieldMapping = (field: keyof CsvColumnMapping, value: string) => {
    const next = { ...props.mapping };
    if (value === "") {
      delete next[field];
    } else {
      next[field] = parseInt(value, 10);
    }
    props.onChange(next);
  };

  return (
    <div class="space-y-3">
      <For each={MAPPABLE_FIELDS}>
        {(field) => (
          <div class="flex items-center gap-3">
            <label class="w-28 shrink-0 text-sm font-medium text-ink-2">
              {field.label}
              <Show when={field.required}>
                <span class="text-signal-red ml-0.5">*</span>
              </Show>
            </label>
            <select
              class="flex-1 border border-line rounded-md px-3 py-1.5 text-sm text-ink-2 bg-surface"
              value={
                props.mapping[field.key] !== undefined
                  ? String(props.mapping[field.key])
                  : ""
              }
              onChange={(e) =>
                setFieldMapping(field.key, e.currentTarget.value)
              }
              aria-label={`Map ${field.label} column`}
            >
              <option value="">— Not mapped —</option>
              <For each={props.headers}>
                {(header, i) => (
                  <option value={String(i())}>
                    {header || `Column ${i() + 1}`}
                  </option>
                )}
              </For>
            </select>
          </div>
        )}
      </For>
    </div>
  );
};
